import { render, staticRenderFns } from "./QuickOrder.vue?vue&type=template&id=c07de654&scoped=true&"
import script from "./QuickOrder.vue?vue&type=script&lang=js&"
export * from "./QuickOrder.vue?vue&type=script&lang=js&"
import style0 from "./QuickOrder.vue?vue&type=style&index=0&id=c07de654&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07de654",
  null
  
)

export default component.exports